import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, message, Table, Popconfirm, Button } from "antd";
import userActions from "../../redux/incentive/actions";
import SearchBar from "../../utils/Searchbar";
import { EditOutlined, DeleteFilled } from "@ant-design/icons";
import UserModal from "./components/IncentiveFormModel";

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    sorter: (a, b) => a.key - b.key,
    width: 100, // Fixed width
  },
  {
    title: "Service Name",
    dataIndex: "serviceName",
    key: "serviceName",
    sorter: (a, b) => a.serviceName?.localeCompare(b.serviceName),
    width: 100, // Fixed width
  },
  {
    title: "Threshold Amount",
    dataIndex: "thresholdAmount",
    key: "thresholdAmount",
    sorter: (a, b) => a.thresholdAmount - b.thresholdAmount,
    width: 100, // Fixed width
  },
  {
    title: "Voucher",
    dataIndex: "voucher",
    key: "voucher",
    width: 100, // Fixed width
  },

  {
    title: "ACTIONS",
    dataIndex: "action",
    width: 100, // Fixed width
  },
];

const {
  getIncentiveData,
  deleteIncentive,
  IncentiveResetMessage,
  openForm,
  IncentiveReset,
  getServices,
  addIncentive,
  editIncentive,
  getVouchersData,
} = userActions;

const Incentive = () => {
  const dispatch = useDispatch();
  const {
    incentiveData,
    loading,
    totalData,
    error,
    show,
    buttonLoading,
    servicelist,
    totalVoucher,
  } = useSelector((state) => state.incentiveReducer || {});
  const profileData = useSelector(state => state.authReducer.profileData);
  const sucessMessage = useSelector((state) => state.incentiveReducer.message);
  const [UserForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [fromTitle, setfromTitle] = useState("");
  const [formButton, setformButton] = useState("");
  const [editFlag, setEditFlag] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedModules, setSelectedModules] = useState([]);
  const [userId, setUserId] = useState();
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const dataSource =
    incentiveData &&
    incentiveData?.length > 0 &&
    incentiveData?.map((service, index) => {
      return {
        key: (tableParams.current - 1) * tableParams?.pageSize + index + 1,
        serviceName: service?.serviceDisplayName,
        thresholdAmount: service?.thresholdAmount,
        voucher: service?.voucher,
        action: (
          <>
            <EditOutlined
              style={{ fontSize: "18px" }}
              onClick={() => handleEdit(service)}
            />
            <Popconfirm
              title="Are you sure to Delete this Incentive"
              okText="Yes"
              cancelText="No"
              placement="topRight"
              onConfirm={() => dispatch(deleteIncentive(service?._id , profileData?.orgId))}
            >
              <DeleteFilled
                style={{
                  fontSize: "18px",
                  color: "#e92121",
                  marginLeft: "10px",
                }}
              />
            </Popconfirm>
          </>
        ),
      };
    });

  let timeoutId;
  const handleFilterChange = (e) => {
    e.preventDefault();
    const value = e.target.value;

    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }

    timeoutId = setTimeout(() => {
      if (incentiveData?.length >= 0 && profileData) {
        dispatch(getIncentiveData(0, 10, "", "" , value , profileData?.orgId));
      }
    }, 1000);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    dispatch(getIncentiveData(current - 1, pageSize, "", "" , profileData?.orgId));
  };

  const success = (text) => {
    const hide = messageApi.open({
      type: "success",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(IncentiveResetMessage());
  };
  const errorHandle = (text) => {
    const hide = messageApi.open({
      type: "error",
      content: text,
    });
    setTimeout(hide, 4000);
    dispatch(IncentiveResetMessage());
  };

  const handleSubmit = (values) => {
    const payload = {
      serviceDisplayName: values?.service,
      thresholdAmount: values?.billAmount,
      voucher: values?.voucher,
      agentId: profileData?.orgId,
    };
    if (editFlag) {
      dispatch(editIncentive(userId, payload));
    } else {
      dispatch(addIncentive(payload));
    }
  };
  const handleEdit = (record) => {
    setEditFlag(true);
    setfromTitle("UPDATE INCENTIVE");
    setformButton("Update");
    UserForm.setFieldsValue({
      billAmount: record?.thresholdAmount,
      service: record?.serviceDisplayName,
      voucher: record?.voucher,

    });
    dispatch(openForm());
    setUserId(record._id);
  };
  const handleCancel = () => {
    dispatch(IncentiveReset());
    UserForm.resetFields();
    setSelectedModules([]);
  };

  const showModal = () => {
    setfromTitle("ADD INCENTIVES");
    setformButton("Submit");
    setEditFlag(false);
    dispatch(openForm());
    UserForm.resetFields();
    setSelectedModules([]);
  };
  const handleModuleChangenew = (selectedModules) => {
    setSelectedModules(selectedModules);
  };

  useEffect(() => {
    if (sucessMessage !== null && sucessMessage !== undefined) {
      success(sucessMessage);
    }
    if (error !== null && error !== undefined) {
      errorHandle(error);
    }
  }, [sucessMessage, error, success, errorHandle]);

  useEffect(() => {
    if(profileData?.orgId) {
      dispatch(getIncentiveData(1 , 10 , "" , "" , "" , profileData?.orgId));
      dispatch(getServices());
      dispatch(getVouchersData(profileData?.orgId));
    }
  }, [dispatch , profileData]);

  return (
    <>
      {contextHolder}
      <div className="mainContain">
        <h1 className="transaction">Incentives</h1>
        <div className="d-flex justify-content-between align-items-center">
          <SearchBar onChange={handleFilterChange} />
          <Button
            style={{
              backgroundColor: "#073763",
              borderColor: "#073763",
              color: "white",
            }}
            size="large"
            onClick={showModal}
          >
            Add Incentive
          </Button>
        </div>
        <div className="mt-3">
          <Table
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            scroll={{ x: 600 }}
            pagination={{
              total: totalData,
              current: tableParams?.current,
              pageSize: tableParams?.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "50"],
            }}
            onChange={handleTableChange}
          />
        </div>
      </div>

      <UserModal
        fromTitle={fromTitle}
        open={show}
        buttonLoading={buttonLoading}
        confirmLoading={confirmLoading}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        formButton={formButton}
        UserForm={UserForm}
        selectedModules={selectedModules}
        editFlag={editFlag}
        servicelist={servicelist}
        totalVoucher={totalVoucher}
        handleModuleChangenew={handleModuleChangenew}
      />
    </>
  );
};

export default Incentive;
